import moment from 'moment';
import rosterService from '@/services/rosterService'
import rosterApi from '../api/rosterApi';
import RosterUtilService from '@/services/rosterUtilService';
import * as Constants from '@/helpers/constants';

const getDefaultState = () => {
    return {
        selectedDate: moment().format('YYYY-MM-DD'),
        showPreviousSunday: false,
        showActuals: false,
        showMultiSelect: false,
        financialYearCalendarData: null,
        loadingPlants: false,
        plantData: null,
        selectedPlantID: null,
        selectedUOM: Constants.HARVESTPLAN_UOM_ENUM.KG.ID,
        loadingWeatherData: false,
        weatherData: null,
        selectedCategoryIDs: [],
        cropLocationVarietyRostersRaw: [],
        cropLocationVarietyRosters: [],
        cropLocationVarietyRostersPreviousDay: [],
        rosterTeamPlans: [],
        rosterTeamPlansByTeam: [],
        rosterTeamPlansPreviousDay: [],
        teamRosterResult: [],
        teamRosterResultPreviousDay: [],
        //This is for local only to show the new added team without any roster value for the selected product category
        //If will refresh when reload the data
        localTeamIDs: [],
        localFilterTeamIDs: []
    }
}

export default {
    namespaced: true,
    state: {
        selectedDate: moment().format('YYYY-MM-DD'),
        showPreviousSunday: false,
        showActuals: false,
        showMultiSelect: false,
        financialYearCalendarData: null,
        loadingPlants: false,
        plantData: null,
        selectedPlantID: null,
        selectedUOM: Constants.HARVESTPLAN_UOM_ENUM.KG.ID,
        loadingWeatherData: false,
        weatherData: null,
        selectedCategoryIDs: [],
        cropLocationVarietyRostersRaw: [],
        cropLocationVarietyRosters: [],
        cropLocationVarietyRostersPreviousDay: [],
        rosterTeamPlans: [],
        rosterTeamPlansByTeam: [],
        rosterTeamPlansPreviousDay: [],
        teamRosterResult: [],
        teamRosterResultPreviousDay: [],
        localTeamIDs: [],
        localFilterTeamIDs: []
    },
    getters: {
        rosterTeamPlansIncludingPreviousDay(state) {
            return state.rosterTeamPlans.concat(state.rosterTeamPlansPreviousDay);
        },
        today(){
            return moment().format('YYYY-MM-DD');
        },
        previousDay(state, getters) {
            return moment(getters.startOfSelectedWeek).add(-1, "day").format('YYYY-MM-DD');
        },
        startOfSelectedPeriod(state, getters) {
            if (state.showPreviousSunday) {
                return getters.previousDay;
            }

            return getters.startOfSelectedWeek;
        },
        startOfSelectedWeek(state) {
            return moment(state.selectedDate)
                .startOf('week')
                .format('YYYY-MM-DD');
        },
        endOfSelectedWeek(state) {
            return moment(state.selectedDate)
                .endOf('week')
                .format('YYYY-MM-DD');
        },
        endOfSixWeeksFromSelected(state){
            return moment(state.selectedDate)
                .add(6, 'weeks')
                .endOf('week')
                .format('YYYY-MM-DD')
        },
        previousDays(state, getters) {
            var days = [];

            var previousDay = moment(getters.previousDay);

            const isToday = (date) => {
                const today = new Date()
                return date.getDate() === today.getDate() &&
                    date.getMonth() === today.getMonth() &&
                    date.getFullYear() === today.getFullYear();
            };

            days.push({ Date: previousDay.toDate(), IsToday: isToday(previousDay.toDate()), IsPast: new Date().setHours(0, 0, 0, 0) > new Date(previousDay).setHours(0, 0, 0, 0) });

            return days;
        },
        daysWithoutPreviousSunday(state) {
            var startOfWeek = moment(state.selectedDate).startOf('week');
            var endOfWeek = moment(state.selectedDate).endOf('week');
            var days = [];
            var day = startOfWeek;
            const isToday = (date) => {
                const today = new Date()
                return date.getDate() === today.getDate() &&
                    date.getMonth() === today.getMonth() &&
                    date.getFullYear() === today.getFullYear();
            };
            while (day <= endOfWeek) {
                days.push({ Date: day.toDate(), IsToday: isToday(day.toDate()), IsPast: new Date().setHours(0, 0, 0, 0) > new Date(day).setHours(0, 0, 0, 0) });
                day = day.clone().add(1, 'd');
            }

            return days;
        },
        days(state, getters) {
            if (state.showPreviousSunday) {
                return [...getters.previousDays, ...getters.daysWithoutPreviousSunday];
            }

            return getters.daysWithoutPreviousSunday;
        },
        duplicatedDays(state, getters) {
            // this is used to render the team & location roster tables, as each day will have two columns

            let duplicatedDays = [];

            for (let i = 0; i < getters.days.length; i++) {
                let day = getters.days[i];

                let volumePart = JSON.parse(JSON.stringify(day));
                let teamPart = JSON.parse(JSON.stringify(day));

                volumePart.Index = i;
                teamPart.Index = i;

                volumePart.IsVolume = true;
                teamPart.IsVolume = false;

                duplicatedDays.push(volumePart);
                duplicatedDays.push(teamPart);
            }

            return duplicatedDays;
        },
        teams(state) {
            if(state.selectedPlantID == null) {
                return [];
            } else {
                return [{ TeamID: -1, TeamName: "Spray" }, ...state.plantData.find(p => p.PlantID == state.selectedPlantID).Teams.sort(function (a, b) {
                    let x = a.TeamName.toLowerCase();
                    let y = b.TeamName.toLowerCase();
                    if (x < y) { return -1; }
                    if (x > y) { return 1; }
                    return 0;
                })];
            }
        },
        selectedTeams(state, getters) {
            return getters.selectedTeamIDs.map(t=> {
                return getters.teams.find(team=> team.TeamID == t);
            })
            .sort(function (a, b) {
                let x = a.TeamName.toLowerCase();
                let y = b.TeamName.toLowerCase();
                if (x < y) { return -1; }
                if (x > y) { return 1; }
                return 0;
            });
        },
        selectedTeamIDs(state) {
            return [... new Set(state.rosterTeamPlans.map(r => r.TeamID))];
        },
        previousDayTeams(state, getters) {
            return getters.previousDayTeamIDs.map(t=> {
                return getters.teams.find(team=> team.TeamID == t);
            })
        },
        previousDayTeamIDs(state) {
            return [... new Set(state.rosterTeamPlansPreviousDay.map(r => r.TeamID))];
        },
        selectedUOMScaleFactors(state) {            
            let uoms = {};

            for (const category of state.plantData.find(p => p.PlantID == state.selectedPlantID).ProductCategories) {
                if (category.DefaultPlantUnit) {
                    for(const varietyID of category.Varieties) {
                        if (state.selectedUOM == Constants.HARVESTPLAN_UOM_ENUM.KG.ID) {
                            uoms[varietyID] = { scaleFactor : 1 };
                        }

                        if (state.selectedUOM == Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID) {
                            uoms[varietyID] = { scaleFactor : 1 / category.DefaultPlantUnit.AveKgsPerUnit / category.DefaultPlantUnit.NumInTray };
                        }
                    }
                }
            }

            return uoms;
        },
        uom(state) {
            if (state.selectedUOM == Constants.HARVESTPLAN_UOM_ENUM.KG.ID) {
                return "kg";
            }

            if (state.selectedUOM == Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID) {
                return "tr";
            }

            return null;
        }
    },
    mutations: {
        setSelectedPlantID(state, selectedPlantID){
            state.selectedPlantID = selectedPlantID;
        },
        setSelectedCategoryIDs(state, selectedCategoryIDs){
            state.selectedCategoryIDs = selectedCategoryIDs;
        },
        setSelectedDate(state, selectedDate) {
            state.selectedDate = selectedDate;
        },
        setShowPreviousSunday(state, newValue) {
            state.showPreviousSunday = newValue;
        },
        setShowActuals(state, newValue) {
            state.showActuals = newValue;
        },
        setShowMultiSelect(state, newValue) {
            state.showMultiSelect = newValue;
        },
        setFilterUOM(state, selectedUOM) {
            state.selectedUOM = selectedUOM;
        }
    },
    actions: {
        async resetState({ state }) {
            Object.assign(state, getDefaultState())
        },
        async loadFinancialYearCalendarData({ state }){
            state.loadingFinancialYearCalendarData = true;

            let financialYearCalendarData = await rosterService.getFinancialYearCalendarsData();

            if(financialYearCalendarData == null){
                financialYearCalendarData = [];
            }
            state.financialYearCalendarData = financialYearCalendarData
            
            state.loadingFinancialYearCalendarData = false;
        },
        async loadPlants({ state }){
            state.loadingPlants = true;

            let plantData = await rosterService.getPlantData();
            if(plantData == null){
                plantData = [];
            }

            state.plantData = plantData;
        
            state.loadingPlants = false;
        },
        async loadWeatherData({ state, getters }){
            state.loadingWeatherData = true;

            state.weatherData = await rosterService.getWeatherData(
                state.selectedPlantID,
                getters.startOfSelectedWeek,
                getters.endOfSixWeeksFromSelected
            );
           
            state.loadingWeatherData = false;
        },
        async loadCropLocationVarietyRosterData({ state, getters, dispatch }) {
            var startDate = new Date();

            state.cropLocationVarietyRostersRaw = await rosterService.getCropLocationVarietyRosters(
                state.selectedPlantID,
                state.selectedCategoryIDs,
                getters.startOfSelectedPeriod,
                getters.endOfSelectedWeek,
                null
            );

            await dispatch("mapCropLocationVarietyRosters");

            var endDate = new Date();
            var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
            console.log(seconds + " seconds");
        },

        async mapCropLocationVarietyRosters({ state, getters }) {
            // Need to create a deep copy of the data as it will be mutated
            let cropLocationVarietyRosters = JSON.parse(JSON.stringify(state.cropLocationVarietyRostersRaw));            

            var mapped = RosterUtilService.mapCropLocationVarietyRosters(getters.days, cropLocationVarietyRosters, getters.selectedUOMScaleFactors, state.showPreviousSunday);
            state.cropLocationVarietyRosters = mapped;
        },

        async updateCropLocationVarietyRosters({ state, getters, dispatch }, cropLocationVarietyRosters) {
            let result = RosterUtilService.convertBackToKg(cropLocationVarietyRosters, getters.selectedUOMScaleFactors);
            await rosterApi.updateCropLocationVarietyDayRosters(result);

            let cropLocationVarietyRostersRaw = await rosterService.getCropLocationVarietyRosters(
                state.selectedPlantID,
                state.selectedCategoryIDs,
                getters.startOfSelectedPeriod,
                getters.endOfSelectedWeek,
                cropLocationVarietyRosters.CropLocationID
            );

            if (cropLocationVarietyRostersRaw.length == 1) {
                let index = state.cropLocationVarietyRostersRaw.indexOf(state.cropLocationVarietyRostersRaw.find(c => c.CropLocationID == cropLocationVarietyRosters.CropLocationID));
                
                state.cropLocationVarietyRostersRaw[index] = cropLocationVarietyRostersRaw[0];
                
                await dispatch("mapCropLocationVarietyRosters");
                await dispatch("loadTeamRosterResult");
            }
        },
        async updateCropLocationVarietyRosters_NoReload({ state, getters, dispatch }, cropLocationVarietyRosters) {
            let result = RosterUtilService.convertBackToKg(cropLocationVarietyRosters, getters.selectedUOMScaleFactors);
            await rosterApi.updateCropLocationVarietyDayRosters(result);

            let cropLocationVarietyRostersRaw = await rosterService.getCropLocationVarietyRosters(
                state.selectedPlantID,
                state.selectedCategoryIDs,
                getters.startOfSelectedPeriod,
                getters.endOfSelectedWeek,
                cropLocationVarietyRosters.CropLocationID
            );

            if (cropLocationVarietyRostersRaw.length == 1) {
                let index = state.cropLocationVarietyRostersRaw.indexOf(state.cropLocationVarietyRostersRaw.find(c => c.CropLocationID == cropLocationVarietyRosters.CropLocationID));
                
                state.cropLocationVarietyRostersRaw[index] = cropLocationVarietyRostersRaw[0];
            }
        },
        async reloadCropLocationVarietyRosters({ state, getters, dispatch }) {
            await dispatch("mapCropLocationVarietyRosters");
            await dispatch("loadTeamRosterResult");
        },
        async updateCropLocationDaysVarietyRosters({ getters, dispatch }, cropLocationVarietyRosterList) {
            let data = [];

            for (const item of cropLocationVarietyRosterList) {
                let result = RosterUtilService.convertBackToKg(item, getters.selectedUOMScaleFactors);
                data.push(result);
            }

            await rosterApi.updateCropLocationDaysVarietyRosters(data);

            await dispatch("loadTeamRosterResult");
        },
        async loadRosterTeamPlans({ state, getters, dispatch }) {
            var rosterTeamPlans = await rosterService.getRosterTeamPlans(
                state.selectedPlantID,
                state.selectedCategoryIDs,
                getters.startOfSelectedWeek,
                getters.endOfSelectedWeek
            );

            state.rosterTeamPlans = rosterTeamPlans;

            state.rosterTeamPlansPreviousDay = [];

            if (state.showPreviousSunday) {
                var rosterTeamPlansPreviousDay = await rosterService.getRosterTeamPlans(
                    state.selectedPlantID,
                    state.selectedCategoryIDs,
                    getters.previousDay,
                    getters.previousDay
                );

                state.rosterTeamPlansPreviousDay = rosterTeamPlansPreviousDay;
            }

            state.rosterTeamPlansByTeam = RosterUtilService.mapRosterTeamPlans(getters.rosterTeamPlansIncludingPreviousDay, getters.days, state.showPreviousSunday);

            await dispatch("loadTeamRosterResult");
        },

        async cleanUpRosterTeamPlans({ state, getters }) {
            await rosterService.cleanUpRosterTeamPlans(
                state.selectedPlantID,
                getters.startOfSelectedWeek,
                getters.endOfSelectedWeek
            );
        },

        async updateRosterTeamPlans( context , rosterTeamPlans) {
            await rosterService.updateRosterTeamPlans(rosterTeamPlans);
            await context.dispatch("loadRosterTeamPlans");
        },
        async loadTeamRosterResult({ state, getters}) {
            state.teamRosterResult = [];
            
            if(getters.selectedTeamIDs.length > 0) {
                var teamRosterResult = await rosterService.loadTeamRosterResult(getters.selectedTeamIDs, getters.startOfSelectedWeek, getters.endOfSelectedWeek);
                state.teamRosterResult = teamRosterResult;
            }

            if (getters.previousDayTeamIDs.length > 0) {
                var teamRosterResultPreviousDay = await rosterService.loadTeamRosterResult(getters.previousDayTeamIDs, getters.previousDay, getters.previousDay);
                state.teamRosterResultPreviousDay = teamRosterResultPreviousDay;
            }
        },
        async clearLocalTeamIDs({ state }) {
            state.localTeamIDs = [];
        },
        async addLocalTeamIDs({ state }, teamIDs) {
            state.localTeamIDs = [... new Set(state.localTeamIDs.concat(teamIDs))];
        },
        async removeLocalTeamIDs({ state }, teamIDs) {
            state.localTeamIDs = state.localTeamIDs.filter(t=> {
                return teamIDs.indexOf(t) < 0;
            });
        },
        async clearLocalFilterTeamIDs({state}){
            state.localFilterTeamIDs = [];
        },
        async localFilterTeamIDChange({state}, teamIDs) {
            console.log('store', new Set(teamIDs))
            state.localFilterTeamIDs = [... new Set(teamIDs)]
        }
    }
}

